import PropTypes from 'prop-types';
import merge from 'lodash/merge';

import Chart from '../../charts/Chart';
import 'highcharts/modules/venn';

import { vennDiagramConfiguration } from './utilities/helpers';

const VennDiagram = ({ data, ...props }) => {
  return (
    <Chart
      options={merge({}, vennDiagramConfiguration, {
        series: [{ data }],
        type: 'venn',
        ...props,
      })}
      {...props}
    />
  );
};

VennDiagram.defaultProps = {
  data: [],
};

VennDiagram.propTypes = {
  data: PropTypes.array.isRequired,
};

export default VennDiagram;
